// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbItem":"AppBreadcrumb_breadcrumbItem__3n5fk","last":"AppBreadcrumb_last__3KMU_"};